import moment from 'moment';

const formatLocalDateTime = (isoString) => {
  if (!isoString) return null;
  return moment(isoString).format('M/D/YYYY, h:mm A');
};

const formatGMT8DateTime = (isoString) => {
  if (!isoString) return null;
  return moment(isoString).utcOffset('+08:00').format('M/D/YYYY, h:mm A');
};

const getToday = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

function formatDateToMMDDYYYY(dateString) {
  // Expect input in yyyy-mm-dd format
  const [year, month, day] = dateString.split("-");
  return `${month}/${day}/${year}`;
}

export { formatLocalDateTime, formatGMT8DateTime, getToday, formatDateToMMDDYYYY }

